export var CemeterySearchOption;
(function (CemeterySearchOption) {
    CemeterySearchOption["Cemetery"] = "Cemetery";
})(CemeterySearchOption || (CemeterySearchOption = {}));
